import { render, staticRenderFns } from "./TableSortIcon.vue?vue&type=template&id=cc37cc12&scoped=true&"
import script from "./TableSortIcon.vue?vue&type=script&lang=js&"
export * from "./TableSortIcon.vue?vue&type=script&lang=js&"
import style0 from "./TableSortIcon.vue?vue&type=style&index=0&id=cc37cc12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc37cc12",
  null
  
)

export default component.exports